import React, { useState, useCallback, useEffect, useMemo } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Icon,
  Autocomplete,
  Select,
  Divider,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useNavigate, useParams } from "react-router-dom";
import { usavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";
import Select2 from "react-select";
import { SearchIcon } from "@shopify/polaris-icons";
import { PlusIcon } from "@shopify/polaris-icons";
import { MultiSelect } from "primereact/multiselect";
import JoditEditor from "jodit-react";
import { EDITOR_CONFIG } from "../../../constants";
const AddEditEventSessionExisting = (props) => {
  const navigate = useNavigate();
  const { id, sessionId } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [optionsClasses, setOptionsClasses] = useState([]);
  const handleSelectChangeClass = (newValue) => {
    setItem({ ...item, class: newValue });
    setClassError("");
  };
  const [classError, setClassError] = useState("");
  const [optionsSessions, setOptionsSessions] = useState([]);
  const handleSelectChangeSession = (newValue) => {
    setItem({ ...item, session: newValue });
    setSessionError("");
  };
  const [sessionError, setSessionError] = useState("");
  const [item, setItem] = useState({ is_active: true, class: "", session: "" });
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have be saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;
  useEffect(() => {
    setOptionsSessions([]);
    console.log(item.class);
    if (item.class !== "" && item.class.value !== "") {
      axios
        .get(`/classes/${item.class.value}/sessions-list`)
        .then((result) => {
          console.log(result.data.data);
          setOptionsSessions(
            result.data.data.map((item, index) => {
              return {
                label: `(ID:${item.id}) ${item.name ? item.name + " " : ""} ${
                  item.date
                } ${item.launch_time} - ${item.finish_time}`,
                value: String(item.id),
              };
            })
          );
        })
        .catch((err) => console.log(err));
    }
  }, [item.class]);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    let responseItem = "";
    let responseClasses = [];

    try {
      responseClasses = await axios.get(`/classes-list`);
      setOptionsClasses(
        responseClasses.data.data.map((item, index) => {
          return {
            label: `${item.name ? item.name + " " : ""}(ID:${item.id})`,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    // if (props.type === "edit") {
    //   try {
    //     responseItem = await axios.get(`/classes/${id}/sessions/${sessionId}`);
    //     setItem({
    //       is_active: responseItem?.data?.data?.is_active ? true : false,
    //       class:
    //         responseItem?.data?.data?.related_class == null
    //           ? {
    //               label: responseItem?.data?.data?.related_class?.name,
    //               value: String(responseItem?.data?.data?.related_class?.id),
    //             }
    //           : "",
    //     });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }
    setIsSaving(false);
  }

  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Existing Session`}
      backAction={{
        onAction: () => navigate(`/admin/${props.path}/${id}/sessions`),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout.Group>
          <FormLayout>
            <Text>Class</Text>
            <Select2
              options={optionsClasses}
              onChange={handleSelectChangeClass}
              value={item.class}
              placeholder="Please select"
              styles={{
                // container: (provided) => ({
                //   ...provided,
                //   width: "300px",
                // }),
                menu: (provided) => ({
                  ...provided,
                  maxHeight: "100px",
                  overflowY: "auto",
                }),
                menuList: (provided) => ({
                  ...provided,
                  maxHeight: "100px",
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPosition="absolute"
            />
            <InlineError message={classError} />
            <div style={{ height: "100px" }}></div>
          </FormLayout>

          <FormLayout>
            <Text>Session</Text>
            <Select2
              options={optionsSessions}
              onChange={handleSelectChangeSession}
              value={item.session}
              placeholder="Please select"
              styles={{
                // container: (provided) => ({
                //   ...provided,
                //   width: "300px",
                // }),
                menu: (provided) => ({
                  ...provided,
                  maxHeight: "100px",
                  overflowY: "auto",
                }),
                menuList: (provided) => ({
                  ...provided,
                  maxHeight: "100px",
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPosition="absolute"
            />
            <InlineError message={sessionError} />
            <div style={{ height: "100px" }}></div>
          </FormLayout>
        </FormLayout.Group>
      </Card>

      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/classes/${id}/sessions/${sessionId}`)
                  .then((result) => {
                    navigate(`/admin/classes/${id}/sessions`);
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      />
      {toastMarkup}
    </Page>
  );

  function handleSave() {
    if (item.class === "" || item.session === "") {
      item.class === "" && setClassError("Please select a class");
      item.session === "" && setSessionError("Please select a session");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("existing_session_id", item.session.value);
      props.type === "edit" && form_data.append("_method", "PATCH");
      form_data.append("is_active", item.is_active ? 1 : 0);
      props.type === "add"
        ? axios
            .post(`/classes/${id}/sessions`, form_data)
            .then((result) => {
              navigate(`/admin/events/${id}/sessions`);
            })
            .catch((error) => {
              console.log("error=", error.response.data.message);

              setIsSaving(false);
            })
        : axios
            .post(`/classes/${id}/sessions/${sessionId}`, form_data)
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
};

export default AddEditEventSessionExisting;
